import { ViewProps } from './document.constants';
import { PrintStimulusAspectRatio } from '../print/print-stimulus';
import { CommonPrintProps } from 'approot/activity-builder/activity-builder.constants';
import { getPrintImage } from '../shared/logic/get-print-image';

const DocumentPrint = (props: ViewProps & CommonPrintProps) =>
  props.stimulusResourceProperties?.documentKey ? (
    <PrintStimulusAspectRatio
      dimensions={props.properties.dimensionData}
      coverImage={
        getPrintImage(
          props.stimulusResourceProperties.xlCoverImageUrls || null
        ) || props.stimulusResourceProperties.coverImage?.original
      }
      link={props.stimulusResourceProperties.link}
      isPrintPreview={props.isPrintPreview}
    />
  ) : null;

export default DocumentPrint;
